export enum ErrorMessageResource {
  DUPLICATED_ALIAS= 'payment-method:duplicated_alias'
}